import CryptoJS from 'crypto-js';

// AES 加密密钥
const AES_KEY = 'xiaoyout!#@12345'; // 这里使用一个固定的密钥，实际应用中建议使用更安全的密钥管理方式

// AES 加密函数
export function aesEncrypt(data) {
  const key = CryptoJS.enc.Utf8.parse(AES_KEY);
  const encrypted = CryptoJS.AES.encrypt(data, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
}

// AES 解密函数
export function aesDecrypt(encryptedData) {
  const key = CryptoJS.enc.Utf8.parse(AES_KEY);
  const decrypted = CryptoJS.AES.decrypt(encryptedData, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
} 


// WEBPACK FOOTER //
// ./src/utils/cryptoPwd.js